import React from 'react';
import PropTypes from 'prop-types';

import WriterBadge from '../../../common/writer-badge';

import './team-member-header.css';

const TeamMemberHeader = ({ name, role, twitterUserId, }) => {
  return (
    <div className='team-member-header'>
      <div className='header-titles'>
        <h1>{ name }</h1>
        { role && <h2>{ role }</h2> }
      </div>

      <div className='profile-image-container'>
        <div className='profile-image'>
          <WriterBadge name={ name } />
        </div>
      </div>
    </div>
  );
};

TeamMemberHeader.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.string,
  twitterUserId: PropTypes.string,
};

export default TeamMemberHeader;